'use client'

import React, { useState } from 'react'
import { Check, Link2, Linkedin, Mail, Twitter } from 'lucide-react'

const BUTTON =
  'inline-flex h-10 w-10 items-center justify-center rounded-control border border-rule-strong bg-surface text-ink transition-colors hover:border-signal hover:text-signal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal'

export function ShareButtons({ url, title }) {
  const [copied, setCopied] = useState(false)
  const u = encodeURIComponent(url)
  const t = encodeURIComponent(title)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className="flex gap-2">
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${u}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Auf LinkedIn teilen"
        className={BUTTON}
      >
        <Linkedin aria-hidden className="h-4 w-4" />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${u}&text=${t}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Auf X teilen"
        className={BUTTON}
      >
        <Twitter aria-hidden className="h-4 w-4" />
      </a>
      <a
        href={`mailto:?subject=${t}&body=${u}`}
        aria-label="Per E-Mail teilen"
        className={BUTTON}
      >
        <Mail aria-hidden className="h-4 w-4" />
      </a>
      <button
        type="button"
        onClick={copy}
        aria-label={copied ? 'Link kopiert' : 'Link kopieren'}
        className={BUTTON}
      >
        {copied ? (
          <Check aria-hidden className="h-4 w-4 text-success" />
        ) : (
          <Link2 aria-hidden className="h-4 w-4" />
        )}
      </button>
    </div>
  )
}
